import { render, staticRenderFns } from "./historial_precios.vue?vue&type=template&id=29b08d32&"
import script from "./historial_precios.vue?vue&type=script&lang=js&"
export * from "./historial_precios.vue?vue&type=script&lang=js&"
import style0 from "./historial_precios.vue?vue&type=style&index=0&id=29b08d32&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports